module.exports = __webpack_public_path__ + "static/media/country_nz.0baae708.webp";